"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatBubble = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.ChatBubble = function (props) {
    return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { width: "22", height: "22", viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M18.3333 1.83301H3.66666C2.65374 1.83301 1.83333 2.65342 1.83333 3.66634V20.1663L5.49999 16.4997H18.3333C19.3462 16.4997 20.1667 15.6793 20.1667 14.6663V3.66634C20.1667 2.65342 19.3462 1.83301 18.3333 1.83301Z", fill: props.fill || common_styles_1.black })));
};
//# sourceMappingURL=chat-bubble.js.map